export default __webpack_public_path__ + "8aaf13d39af304d0de91f9abf4e60f44.png";